import { Table } from "antd";
import CardOverTimeTable from "../../../../components/Card/CardOverTimeTable";
import useOverTimeTable from "../hooks/OvertimeTable";



const OverTimeTable = ({ listOfYears, year, updateYear, projects, isLoading }) => {
    const { columns } = useOverTimeTable();
    return (
        <div className="w-full  h-full  overflow-hidden">
            <CardOverTimeTable
                title={"Concentrado de proyectos en rojo"}
                listValues={listOfYears}
                currentValue={year}
                updateValue={updateYear}
                numberOfProjects={projects.length}
            >
                <Table
                    loading={isLoading}
                    key={1000}
                    width={2000}
                    style={{ fontSize: 12 }}
                    pagination={false}
                    columns={columns}
                    dataSource={projects}
                    scroll={{
                        x: 1900,
                    }}
                    sticky={{
                        offsetHeader: 0,
                    }}
                />
            </CardOverTimeTable>
        </div>
    );
};

export default OverTimeTable;
